/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/refresh': {
    width: 15.99,
    height: 16,
    viewBox: '0 0 15.99 16',
    data: '<path pid="0" d="M13.64 2.35A7.958 7.958 0 007.99 0C3.57 0 0 3.58 0 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08a5.99 5.99 0 01-5.65 4c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L8.99 7h7V0z" _fill="#272c33"/>'
  }
})
